var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSap = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M2.5 28.497V11.5h35L20.187 28.497zm20.974-8.863h-.76v-2.727h.76c1.012 0 1.817.33 1.817 1.348 0 1.049-.805 1.379-1.817 1.379m-8.165 1.944c-.402 0-.78-.07-1.104-.192l1.092-3.381h.023l1.07 3.391a3.2 3.2 0 0 1-1.081.182m7.962-6.883h-3.445v8.04l-3.01-8.04h-2.984l-2.57 6.723c-.272-1.694-2.06-2.28-3.465-2.72-.93-.292-1.913-.723-1.904-1.199.007-.39.529-.752 1.56-.698.692.037 1.304.091 2.52.668l1.199-2.047c-1.112-.555-2.646-.905-3.903-.907H7.26c-1.466 0-2.688.468-3.445 1.236a2.83 2.83 0 0 0-.825 1.972c-.019 1.039.369 1.774 1.184 2.362.687.495 1.567.816 2.342 1.053.956.29 1.737.543 1.727 1.082a.77.77 0 0 1-.225.527c-.24.242-.605.333-1.11.343-.978.019-1.701-.13-2.853-.8L2.99 24.366a8.1 8.1 0 0 0 3.9 1.019l.179-.002c1.21-.02 2.185-.36 2.966-.976q.064-.051.125-.107l-.344.907h3.128l.526-1.568a5.9 5.9 0 0 0 1.839.285 5.9 5.9 0 0 0 1.796-.27l.506 1.553h5.103v-3.248h1.113c2.69 0 4.283-1.344 4.283-3.6 0-2.51-1.546-3.663-4.84-3.663Zm1.826 12.623h.235c.165 0 .312-.01.312-.206 0-.159-.144-.186-.278-.186h-.269zm0 .164v.55h-.195v-1.27h.493c.305 0 .456.111.456.361 0 .228-.146.328-.336.35l.37.56h-.221l-.341-.551zm.238 1.018c-.618 0-1.14-.468-1.14-1.105 0-.633.522-1.1 1.14-1.1.611 0 1.134.467 1.134 1.1 0 .637-.523 1.105-1.134 1.105m-.914-1.105c0 .53.401.92.914.92.507 0 .909-.39.909-.92a.9.9 0 0 0-.909-.917.9.9 0 0 0-.914.917",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1752.5,
    x2: 1752.5,
    y1: 11.5,
    y2: 1711.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49B4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B63BB"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sap.8d6f47e1.svg";